import { Factory } from 'rosie';

Factory.define('CustomerMatch').attr('name', 'CUSTOMER_MATCH');

Factory.define('CustomerMatchWithDefaults')
  .extend('CustomerMatch')
  .attr('profiles', []);
